/** Perfil de cliente — español */
export const CLIENT_PROFILE_ES = {
  'clientProfile.title': 'Perfil del cliente',
  'clientProfile.edit': 'Editar',
  'clientProfile.changePhoto': 'Cambiar foto',
  'clientProfile.statusActive': 'Activo',
  'clientProfile.statusInactive': 'Inactivo',
  'clientProfile.displayNameFallback': 'Cliente',
  'clientProfile.trainerComment': 'Nota',
  'clientProfile.editTrainerComment': 'Editar nota',
  'clientProfile.deleteTrainerComment': 'Eliminar nota',
  'clientProfile.deleteTrainerCommentTitle': '¿Eliminar nota?',
  'clientProfile.deleteTrainerCommentDesc':
    'Se quitará la nota. Puedes volver a escribirla editando el perfil.',
  'clientProfile.metricsHeight': 'Altura',
  'clientProfile.metricsWeight': 'Peso',
  'clientProfile.editProfileTitle': 'Editar perfil',
  'clientProfile.savingProfile': 'Guardando…',
  'clientProfile.saveProfileChanges': 'Guardar cambios',
  'clientProfile.nameLabel': 'Nombre',
  'clientProfile.namePlaceholder': 'Nombre del cliente',
  'clientProfile.clientNoteLabel': 'Nota',
  'clientProfile.clientNotePlaceholder': 'Nota sobre el cliente…',
  'clientProfile.navCalendar': 'Calendario',
  'clientProfile.navExercises': 'Ejercicios',
  'clientProfile.navPayments': 'Pagos',
  'clientProfile.workoutsHeading': 'Entrenos',
  'clientProfile.openPaymentCalendar': 'Calendario de pagos',
  'clientProfile.paymentCalendarAndSessions': 'Calendario de pagos y sesiones',
  'clientProfile.upcoming': 'Próximos',
  'clientProfile.past': 'Pasados',
  'clientProfile.loading': 'Cargando…',
  'clientProfile.loadingExercises': 'Cargando ejercicios…',
  'clientProfile.noUpcomingWorkouts': 'No hay entrenos próximos',
  'clientProfile.noPastWorkouts': 'No hay entrenos pasados',
  'clientProfile.paginationShown': 'Mostrando {from}-{to} de {total} entrenos',
  'clientProfile.pageOf': 'Página {page} de {pages}',
  'clientProfile.back': 'Atrás',
  'clientProfile.next': 'Siguiente',
  'clientProfile.exercisesHeading': 'Ejercicios',
  'clientProfile.addExerciseBtn': 'Añadir ejercicio',
  'clientProfile.addExerciseWithWeight': 'Añadir ejercicio y peso',
  'clientProfile.searchExercisePlaceholder': 'Buscar ejercicio…',
  'clientProfile.noExercisesEmpty': 'Aún no hay ejercicios',
  'clientProfile.noExercisesFound': 'No se encontraron ejercicios',
  'clientProfile.colExercise': 'Ejercicio',
  'clientProfile.colWorkingWeightKg': 'Peso de trabajo, kg',
  'clientProfile.editWorkingWeightTitle': 'Editar peso de trabajo',
  'clientProfile.deleteProfileBtn': 'Quitar cliente',
  'clientProfile.deleteProfileAria': 'Eliminar perfil del cliente',
  'clientProfile.paymentCalendarTitle': 'Calendario de pagos',
  'clientProfile.paymentCalendarDesc': 'Resumen mensual de pagos',
  'clientProfile.legendPaid': 'Pagado',
  'clientProfile.legendUnpaid': 'Sin pagar',
  'clientProfile.legendPaidCount': 'Sesiones prepagadas registradas',
  'clientProfile.addWorkoutTitle': 'Añadir entreno',
  'clientProfile.addWorkoutIntro': 'Programa una sesión nueva para {name}',
  'clientProfile.rescheduleNewDate': 'Nueva fecha',
  'clientProfile.rescheduleNewTime': 'Nueva hora',
  'clientProfile.comboboxEmpty': 'Ejercicio no está en el diccionario',
  'clientProfile.comboboxCreate': 'Añadir a mi diccionario',
  'clientProfile.comboboxHint': 'Elige de la lista o escribe un nombre nuevo',
  'clientProfile.standardExercises': 'Ejercicios estándar',
  'clientProfile.myDictionary': 'Mi diccionario',
  'clientProfile.addSetShort': 'Añadir',
  'clientProfile.addSetLong': 'Añadir serie',
  'clientProfile.addAnotherSet': 'Añadir otra serie',
  'clientProfile.volumeTotal': 'Volumen total: {kg} {unit}',
  'clientProfile.unitKg': 'kg',
  'clientProfile.editWorkoutTitle': 'Editar entreno',
  'clientProfile.editWorkoutHint': 'Actualizar detalles de la sesión',
  'clientProfile.exerciseConfirmNo': 'No',
  'clientProfile.exerciseConfirmYes': 'Sí, añadirlo',
  'clientProfile.deleteClientTitle': 'Quitar cliente',
  'clientProfile.deleteClientLabel': 'Cliente:',
  'clientProfile.deleteDeactivateTitle': 'Desactivar',
  'clientProfile.deleteDeactivateDesc':
    'Las sesiones futuras se eliminan o cancelan. Las pasadas, pagos, ejercicios y pesos de trabajo se conservan. El cliente deja de verse en tu lista.',
  'clientProfile.deleteFullTitle': 'Eliminar por completo',
  'clientProfile.deleteFullDesc':
    'Elimina todo: entrenos, pagos, ejercicios y pesos de trabajo. No se puede deshacer.',
  'clientProfile.deleting': 'Procesando…',
  'clientProfile.deleteFullConfirm': 'Eliminar por completo',
  'clientProfile.deleteDeactivateConfirm': 'Desactivar',
  'clientProfile.deleteWorkoutTitle': 'Eliminar entreno',
  'clientProfile.deleteWorkoutConfirm': '¿Eliminar el entreno del {date} a las {time}?',
  'clientProfile.recurringWorkout': 'Este entreno es recurrente',
  'clientProfile.deleteThisOnly': 'Eliminar solo esta sesión',
  'clientProfile.deleteWholeSeries': 'Eliminar toda la serie recurrente',
  'clientProfile.deleteSeries': 'Eliminar serie',
  'clientProfile.deleteWorkoutAction': 'Eliminar entreno',
  'clientProfile.exerciseLinePrefix': 'Ejercicio:',
  'clientProfile.errInvalidWeightValue': 'Introduce un peso válido',
  'clientProfile.enterWeightPlaceholder': 'Introduce el peso',
  'clientProfile.manualExerciseIntro': 'Elige un ejercicio del catálogo.',
  'clientProfile.searchLabel': 'Buscar',
  'clientProfile.searchExerciseStart': 'Empieza a escribir un nombre…',
  'clientProfile.manualListEmpty': 'No hay resultados o ya está en la lista',
  'clientProfile.selectedLabel': 'Seleccionado:',
  'clientProfile.workingWeightKgLabel': 'Peso de trabajo, kg',
  'clientProfile.weightExample': 'p. ej. 40',
  'clientProfile.pickAvatar': 'Elegir avatar',
  'clientProfile.addExerciseToWorkout': 'Añadir un ejercicio nuevo al entreno del {date}',
  'clientProfile.chosenDateFallback': 'la fecha elegida',

  'clientProfile.dictExerciseAdded': 'El ejercicio «{name}» se añadió a tu diccionario',
  'clientProfile.errLoadClient': 'No se pudieron cargar los datos del cliente',
  'clientProfile.errPaymentCalLoad': 'No se pudo cargar el calendario de pagos',
  'clientProfile.errWithMessage': 'Error: {msg}',
  'clientProfile.successWorkoutCancelled': 'Entreno cancelado',
  'clientProfile.errCancelWorkout': 'No se pudo cancelar el entreno',
  'clientProfile.successWorkoutMoved': 'Entreno reprogramado',
  'clientProfile.errTransferWorkout': 'No se pudo reprogramar el entreno',
  'clientProfile.errCommentDeleteNotFound': 'Cliente no encontrado',
  'clientProfile.errCommentDeleteServer': 'Error del servidor al eliminar la nota',
  'clientProfile.errCommentDelete': 'No se pudo eliminar la nota',
  'clientProfile.phoneSaved': 'Teléfono guardado',
  'clientProfile.phoneCleared': 'Teléfono eliminado',
  'clientProfile.errPhone': 'No se pudo guardar el teléfono',
  'clientProfile.instagramSaved': 'Instagram guardado',
  'clientProfile.instagramCleared': 'Instagram eliminado',
  'clientProfile.errInstagram': 'No se pudo guardar Instagram',
  'clientProfile.emailSaved': 'Correo guardado',
  'clientProfile.emailCleared': 'Correo eliminado',
  'clientProfile.errEmail': 'No se pudo guardar el correo',
  'clientProfile.weightSaved': 'Peso guardado',
  'clientProfile.weightCleared': 'Peso eliminado',
  'clientProfile.errWeight': 'No se pudo guardar el peso',
  'clientProfile.heightSaved': 'Altura guardada',
  'clientProfile.heightCleared': 'Altura eliminada',
  'clientProfile.errHeight': 'No se pudo guardar la altura',
  'clientProfile.genderSaved': 'Género guardado',
  'clientProfile.genderCleared': 'Género eliminado',
  'clientProfile.errGender': 'No se pudo guardar el género',
  'clientProfile.avatarUpdated': 'Avatar actualizado',
  'clientProfile.errAvatarUpdate': 'No se pudo actualizar el avatar',
  'clientProfile.errPickImage': 'Elige una imagen',
  'clientProfile.errFileSize5mb': 'El archivo debe pesar como mucho 5 MB',
  'clientProfile.avatarUploaded': 'Avatar subido',
  'clientProfile.errAvatarUpload': 'No se pudo subir el avatar',
  'clientProfile.errFileRead': 'No se pudo leer el archivo',
  'clientProfile.errFileProcess': 'No se pudo procesar el archivo',
  'clientProfile.profileUpdated': 'Perfil actualizado',
  'clientProfile.errProfileSave': 'No se pudo guardar el perfil',
  'clientProfile.successSetUpdated': 'Serie actualizada',
  'clientProfile.errSetUpdate': 'No se pudo actualizar la serie',
  'clientProfile.successSetDeleted': 'Serie eliminada',
  'clientProfile.errSetDelete': 'No se pudo eliminar la serie',
  'clientProfile.successWorkoutAdded': 'Entreno añadido',
  'clientProfile.errWorkoutAdd': 'No se pudo añadir el entreno',
  'clientProfile.errTimeConflictShort': 'Conflicto de horario: {clients}',
  'clientProfile.errRecurringConflict':
    'Conflicto al crear el entreno recurrente el {date} a las {time}. Ocupado: {clients}',
  'clientProfile.successWorkoutUpdated': 'Entreno actualizado',
  'clientProfile.errWorkoutUpdate': 'No se pudo actualizar el entreno',
  'clientProfile.errWorkoutNotFound': 'Entreno no encontrado',
  'clientProfile.successSeriesDeleted': 'Se eliminaron {n} entrenos de la serie',
  'clientProfile.errWorkoutDelete': 'No se pudo eliminar el entreno',
  'clientProfile.errNoteAdd': 'No se pudo añadir la nota',
  'clientProfile.toastClientDeleted': 'Cliente y todos sus datos eliminados',
  'clientProfile.toastClientDeactivatedN': 'Cliente desactivado. Eliminados {n} entrenos futuros',
  'clientProfile.toastClientDeactivated': 'Cliente desactivado',
  'clientProfile.errDeleteClient': 'No se pudo eliminar al cliente',
  'clientProfile.errDeactivateClient': 'No se pudo desactivar al cliente',
  'clientProfile.exerciseInList': 'Este ejercicio ya está en la lista',
  'clientProfile.enterWorkingWeight': 'Introduce el peso de trabajo',
  'clientProfile.errWorkingWeightInvalid': 'Introduce un peso de trabajo válido',
  'clientProfile.manualExerciseAdded': 'Ejercicio añadido',
  'clientProfile.errSaveFailed': 'No se pudo guardar',
  'clientProfile.successWorkingWeightUpdated': 'Peso de trabajo actualizado',
  'clientProfile.errNickname': 'No se pudo generar el alias',

  'clientProfile.successWorkoutDeleted': 'Entreno eliminado',
  'clientProfile.errSetRepsInvalid':
    'Serie {n}: indica un número de repeticiones válido (solo enteros)',
  'clientProfile.errSetWeightInvalid':
    'Serie {n}: indica un peso válido (decimal con punto o coma) o déjalo vacío',
  'clientProfile.errDictExerciseExists': 'Este ejercicio ya está en tu diccionario',
  'clientProfile.errSaveExerciseToDict': 'No se pudo guardar el ejercicio',
  'clientProfile.paymentCalPrevMonth': 'Mes anterior',
  'clientProfile.paymentCalNextMonth': 'Mes siguiente',
};
